export default "__VITE_ASSET__53f7bbb7__"